
















































































import {
  computed, defineComponent, ref, watch,
} from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import useInvoiceStatus from '@/useInvoiceStatus';
import modalTableOption from '@/table/invoices/modal';
import useDownloadReport from '@/useDownloadReport';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';

import Modal from '@/components/Modal.vue';

import getInvoice from '@/gql/invoice/getInvoice.gql';

const CommonModalWithInvoiceInfo = defineComponent({
  components: {
    Modal,
  },
  setup() {
    const modal = ref(null);
    const invoiceId = ref(-1);
    const { distanceTypeToChipClass } = useDeliveryAreaCode();
    const { getPDFReport } = useDownloadReport();
    function open(id: number) {
      invoiceId.value = id;
      (modal.value as any).open();
    }
    function close() {
      (modal.value as any).close();
      invoiceId.value = -1;
    }
    const { invoiceStatusClassMap, translate, DEFAULT_INVOICE } = useInvoiceStatus();
    const { result: getInvoiceResult, loading: getInvoiceLoading } = useQuery(getInvoice, computed(() => ({
      id: invoiceId.value,
    })), computed(() => ({
      enabled: invoiceId.value > -1,
    })));
    const invoice = computed(() => getInvoiceResult?.value?.invoice || { ...DEFAULT_INVOICE });
    watch(() => invoice.value, (newVal) => {
      // if (!getInvoiceLoading.value && newVal.id > -1) {
      // }
    });

    function getAddressString(containableAddressObject: any): string {
      if (!containableAddressObject || !containableAddressObject.province?.id) return '';
      if (!containableAddressObject.district?.id) return '';
      if (!containableAddressObject.subdistrict?.id) return '';
      const subdistrict = containableAddressObject.subdistrict?.nameInThai !== 'NULL' ? containableAddressObject.subdistrict.nameInThai : containableAddressObject.subdistrict.nameInThai;
      return `${containableAddressObject.address}${subdistrict} ${containableAddressObject.district.nameInThai} ${containableAddressObject.province.nameInThai} ${containableAddressObject.zipcode}`;
    }

    const computedTotalInvoiceAmount = computed(() => {
      const totalPrice = invoice.value.amount || 0;
      const summary = invoice.value.amount - invoice.value.discount;

      return { totalPrice, summary };
    });

    return {
      modal,
      invoice,
      modalTableOption,
      distanceTypeToChipClass,
      open,
      close,
      invoiceStatusClassMap,
      translate,
      computedTotalInvoiceAmount,
      getAddressString,
      getPDFReport,
    };
  },
});

export default CommonModalWithInvoiceInfo;
